import { render, staticRenderFns } from "./AiFeedbackForm.vue?vue&type=template&id=3c58d9cc&scoped=true"
import script from "./AiFeedbackForm.vue?vue&type=script&lang=js"
export * from "./AiFeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./AiFeedbackForm.vue?vue&type=style&index=0&id=3c58d9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58d9cc",
  null
  
)

export default component.exports